export default "__VITE_ASSET__DsAr6L0P__"